<template>
<div>

<compFormEdit ref="formbase" class="margin-layout" :formdata="getBase" v-model="formData"  :labelWidth="120"></compFormEdit>
  <vButtonGroup class="text-right">
          <vButton @click="submit" theme="primary">{{$t('global.modal.confirm', { defaultValue: "确定" })}}</vButton>
          <vButton @click="cancel">{{$t('global.common.cancel', { defaultValue: "取消" })}}</vButton>
  </vButtonGroup>
  <vLoading loading size="large" transfer v-if="loading"></vLoading>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import mixin from "../mixin";
import {
    HttpAddressList,
    HttpSaveCostPrediction,
    HttpCostGetOne
} from "@/service/logistics";
export default {
  mixins: [mixin],
  props: ["activeid","type", "costType"],
  created() {
    this.getDetail();
    this.getAddress();
      
  },
  data() {
    return {
      loading: false,
      id:  this.activeid,
      addressCodeList:[],
      formData: {
          subType:"other_cdfee",
      },
      required: [
        {
          required: true,
          message: "该信息不能为空,请填写"
        }
      ],
    };
  },
  computed: {
      ...mapGetters('dictionary', ['getCompanyList','getFBBFilterDisabledAllWarehouse',"getSystemPortList"]),
      isAdd() {
        return this.type === 'add'
      },
        isLocal() {
			return this.costType === 'local_port'
		},
        isOcean() {
			return this.costType === 'ocean'
		},
        isDischargeHandle() {
			return this.costType === 'discharge_handle'
		},
        isTruck() {
			return this.costType === 'truck'
		},
        isDischarge() {
			return this.costType === 'discharge'
        },
        isPallet() {
			return this.costType === 'pallet'
        }, 
        isAmazonTruck() {
			return this.costType === 'amazon_truck'
        },
        isOther() {
			return this.costType === 'other'
    },
      isSubType() {
			return this.formData.subType === "other_cdfee"
		},
     getBase() {
			return [{
				label: this.$t('fbb.headlogistics.forwarder', { defaultValue: '货代公司' }),
				key: this.isAdd ? "carrierId" : "carrier",
        tag: "vSelect",
        query:!this.isAdd,
        span:24,
				options: this.isAdd ? this.getCompanyList : null,
				props: {
        filterable: true
            },
        on: {
						'on-attach': (val) => this.formData.carrier = val.name
					}
			},{
				label: this.$t('fbb.logistics.cost_port', { defaultValue: '港口' }),
        key: this.isAdd ? "shipPortId" : "shipPort",
        show:this.isLocal,
        span:24,
        query:!this.isAdd,
				tag: "vSelect",
        options: this.isAdd ? this.getSystemPortList : null,	
        on: {
						'on-attach': (val) => this.formData.shipPort = val.title
					}			
			},{
				label: this.$t('fbb.headlogistics.ship_port', { defaultValue: '发运港' }),
        key: this.isAdd ? "shipPortId" : "shipPort",
        show:this.isOcean,
        span:24,
        query:!this.isAdd,
				tag: "vSelect",
        options: this.isAdd ? this.getSystemPortList : null,	
        on: {
						'on-attach': (val) => this.formData.shipPort = val.title
					}			
			},{
				label: this.$t('fbb.headlogistics.purpose_port', { defaultValue: '目的港' }),
        key: this.isAdd ? "purposePortId" : "purposePort",
        show:this.isOcean,
        span:24,
        query:!this.isAdd,
				tag: "vSelect",
        options: this.isAdd ? this.getSystemPortList : null,	
          on: {
						'on-attach': (val) => this.formData.purposePort = val.title
					}			
			},{
				label: this.$t('fbb.logistics.cost_discharge_port', { defaultValue: '卸货港' }),
        key: this.isAdd ? "purposePortId" : "purposePort",
        tag: "vSelect",
        span:24,
        query:!this.isAdd,
        show:this.isDischargeHandle||this.isTruck,
        options: this.isAdd ?  this.getSystemPortList : null,	
        on: {
						'on-attach': (val) => this.formData.purposePort = val.title
					}				
			},{
				label: this.$t('erp.b2c.product_orgwarehouse', { defaultValue: '仓库' }),
				key: this.isAdd ? "depotId" : "purposeDepot",
        tag: "vSelect",
        span:24,
        query:!this.isAdd,
        show:this.isTruck||this.isDischarge||this.isPallet,
        options: this.isAdd ? this.getFBBFilterDisabledAllWarehouse : null,		
        props: {
        filterable: true
            },		
			},{
				label: this.$t('fbb.logistics.cost_cabinet', { defaultValue: '柜型' }),
				key: "cabinetType",
        tag: "vSelect",
        query:!this.isAdd,
        span:24,
        show:this.isLocal ||this.isOcean||this.isTruck||this.isDischarge,
				options: this.getCabinetType,				
      },{
				label: this.$t('fbb.logistics.cost_unit', { defaultValue: '单位' }),
				key: "unit",
        tag: "vSelect",
        span:24,
        query:!this.isAdd,
        show:this.isDischarge,
				options: this.getUnitType,				
      },{
				label: this.$t('fbb.warehouse.transit_warehouse', { defaultValue: '中转仓' }),
				key: this.isAdd ? "depotId" : "purposeDepot",
        tag: "vSelect",
        span:24,
        query:!this.isAdd,
        show:this.isAmazonTruck,
        options: this.isAdd ? this.getFBBFilterDisabledAllWarehouse : null,				
			},{
				label: this.$t('fbb.logistics.cost_amazonfc', { defaultValue: 'Amazon FC' }),
				key: this.isAdd ? "amazonId" : "amazonFc",
        tag: "vSelect",
        span:24,
        show:this.isAmazonTruck,
        query:!this.isAdd,
				options: this.isAdd ? this.addressCodeList : null,				
			},{
        label: this.$t('fbb.logistics.cost_amazon_address', { defaultValue: '亚马逊地址详情	' }),
        key:"addressDetail",
        tag: "vInput",
        query:!this.isAdd,
        span:24,
        show:this.isAmazonTruck&&!this.isAdd,				
			},{
				label: this.$t('fbb.logistics.cost_subtype', { defaultValue: '其他费用类型' }),
				key: "subType",
        tag: "vSelect",
        span:24,
        query:!this.isAdd,
        show:this.isOther ,
				options: this.getCostType,				
      },{
				label: this.$t('fbb.logistics.cost_other_cdfee', { defaultValue: '舱单费(USD)' }),
				key: "cost",
        tag: "vInput",
        span:24,
        show:this.isOther&&this.isSubType &&this.isAdd,
        props:{
                placeholder: this.$t('fbb.logistics.cost_please', { defaultValue: "请填写费用" }),
                },
       /*  children(h) {
												return <span slot='append' class=" padding-left-10 padding-right-10">不含拖车费用</span> 
					}, */				
      },{
				label: this.$t('fbb.logistics.cost_other_secapp', { defaultValue: '进口商安全申报费(USD)' }),
				key: "cost",
        tag: "vInput",
        span:24,
        show:this.isOther&&!this.isSubType &&this.isAdd,
        props:{
                placeholder: this.$t('fbb.logistics.cost_please', { defaultValue: "请填写费用" }),
                },
       /*  children(h) {
												return <span slot='append' class=" padding-left-10 padding-right-10">不含拖车费用</span> 
					}, */				
      },{
				label: this.$t('fbb.logistics.cost_amazon_car', { defaultValue: '卡车运费(USD)/车' }),
				key: "cost",
        tag: "vInput",
        span:24,
        show:this.isAmazonTruck ,
        props:{
                placeholder: this.$t('fbb.logistics.cost_please_car', { defaultValue: "请填写卡车运费" }),
                },
       /*  children(h) {
												return <span slot='append' class=" padding-left-10 padding-right-10">不含拖车费用</span> 
					}, */				
      },{
				label: this.$t('fbb.logistics.cost_palm_fee', { defaultValue: '费用(USD)/托' }),
				key: "cost",
        tag: "vInput",
        span:24,
        show:this.isPallet ,
        props:{
                placeholder: this.$t('fbb.logistics.cost_please', { defaultValue: "请填写费用" }),
                },
       /*  children(h) {
												return <span slot='append' class=" padding-left-10 padding-right-10">不含拖车费用</span> 
					}, */				
      },{
				label: this.$t('fbb.logistics.cost_discharge_fee', { defaultValue: '卸货费(USD)' }),
				key: "cost",
        tag: "vInput",
        span:24,
        show:this.isDischarge ,
        props:{
                placeholder: this.$t('', { defaultValue: "请填写卸货费" }),
                },
       /*  children(h) {
												return <span slot='append' class=" padding-left-10 padding-right-10">不含拖车费用</span> 
					}, */				
      },{
				label: this.$t('fbb.logistics.cost_port_cabinet', { defaultValue: '港口费(USD)/柜' }),
				key: "cost",
        tag: "vInput",
        span:24,
        show:this.isLocal ,
        props:{
                placeholder: this.$t('fbb.logistics.cost_no_truck', { defaultValue: "备注:不含拖车费用" }),
                },
       /*  children(h) {
												return <span slot='append' class=" padding-left-10 padding-right-10">不含拖车费用</span> 
					}, */				
      },{
				label: this.$t('fbb.logistics.cost_cabinet_fee', { defaultValue: '费用(USD)/柜' }),
				key: "cost",
        tag: "vInput",
        show:this.isOcean||this.isTruck,
        span:24,
        props:{
                placeholder: this.$t('fbb.logistics.cost_please', { defaultValue: "请填写费用" }),
                },
       /*  children(h) {
												return <span slot='append' class=" padding-left-10 padding-right-10">不含拖车费用</span> 
					}, */				
      },{
				label: this.$t('fbb.logistics.cost_fee', { defaultValue: '费用(USD)' }),
				key: "cost",
        tag: "vInput",
        show:this.isDischargeHandle||(this.isOther&&!this.isAdd),
        span:24,
        props:{
                placeholder: this.$t('fbb.logistics.cost_please', { defaultValue: "请填写费用" }),
                },
       /*  children(h) {
												return <span slot='append' class=" padding-left-10 padding-right-10">不含拖车费用</span> 
					}, */				
      }, {
        label: this.$t('fbb.logistics.cost_date_start', { defaultValue: '有效期开始时间' }),
        span:24,
        key: "effectiveDateStart", 
        tag: "vDatepicker",		
        props:{
              format:'yyyy-mm-dd',
              confirm:false,
              placeholder: this.$t('', { defaultValue: "有效期开始时间默认为：YYYY-MM-DD 00:00:00" }),
          },	
			},{
        label: this.$t('fbb.logistics.cost_date_end', { defaultValue: '有效期截止时间' }),
        span:24,
        key: "effectiveDateEnd", 
        tag: "vDatepicker",		
        props:{
              format:'yyyy-mm-dd',
              confirm:false,
              placeholder: this.$t('', { defaultValue: "有效期截止时间默认为：YYYY-MM-DD 23:59:59" }),
          },	
			}
      ];
     }
        
  },
  methods: {
      getDetail() {
      if (this.isAdd) return;
      this.loading = true;
      if(this.id){
          HttpCostGetOne({ id: this.id }).then(res => {
          this.formData = res.data;
          /* if(this.isOther){
            if(this.formData.depotType===2){
              this.formData.destinationType = 1
            }else{
              this.formData.destinationType = 0
            }
          } */
           if(this.isAmazonTruck){
             this.formData.addressDetail=""
            HttpAddressList({
                    'search[EQ_warehouseType]':2,
                    'search[EQ_id]':this.formData.amazonId,
                    rows: 1000,
                }).then(res=>{
                  
                   this.formData.addressDetail = "国家:"+res.data.content[0].country+" 州/省:"
                   +res.data.content[0].state+" 城市:"+res.data.content[0].city+" 详细地址:"+res.data.content[0].address
                   +" 邮编:"+res.data.content[0].postal+" 联系人:"+res.data.content[0].linkman+" 联系电话:"+res.data.content[0].phone;
                   this.loading = false;
                },err=>{
                  this.$VMessage.error(err.message);
                })
                
          }else{
            this.loading = false;
          }
				}).catch(err => {
					this.loading = false;
					this.$VMessage.error(err.message);
				})
      }
    },
    getAddress(){
      if (!this.isAdd) return;
      if(this.isAmazonTruck){
           HttpAddressList({
                    'search[EQ_warehouseType]':2,
                    rows: 1000,
                }).then(res=>{
                    this.addressCodeList = res.data.content.map(item => {
                return {
                    label: item.code,
                    value: item.id
                } })
                },err=>{
                    this.$VMessage.error(err.message);
                })
      }
    },
    async submit(){
        const valid = await this.$refs.formbase.validate();
        if (!valid) return;
        if(this.isOcean){
            if(this.formData.purposePortId==this.formData.shipPortId){
                this.$VMessage.error(this.$t('fbb.logistics.cost_check_port', { defaultValue: '发运港与目的港不能相同！' }))
                return
            }
        }
        if(!(/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/.test(this.formData.cost))||Number(this.formData.cost) ==0){
                this.$VMessage.error(this.$t('fbb.logistics.cost_check_num', { defaultValue: '请输入大于0的数' }))
                return
        }
        this.loading = true;
        HttpSaveCostPrediction({
          id:this.activeid,
          organizationId: global.SYSID,
          type: this.costType,
          content: this.formData,
        })
          .then(res => {
            this.loading = false;
            this.$VMessage.success(this.$t('fbb.logistics.cost_add_success', { defaultValue: '添加成功' }));
            this.success();
          }, err => {
            this.loading = false;
                this.$VMessage.error(err.message)
            });
    },
   
    success() {
      this.$emit("on-close");
      this.$emit("on-update");
      this.$emit("refreshPage");
    },
    cancel() {
      this.$emit("on-close");
    }
  }
};
</script>
